/**
 * @generated SignedSource<<ab5dd7dce8653920ac95a27c3c679aec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_projectResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FiltersMenu_project">;
  readonly " $fragmentType": "topBar_issueNavigator_projectResult";
};
export type topBar_issueNavigator_projectResult$key = {
  readonly " $data"?: topBar_issueNavigator_projectResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_projectResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_projectResult",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FiltersMenu_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "ee14c20f4b47a219e3636612ede67b90";

export default node;
